var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Md"},[_c('div',{staticClass:"markdown"},[_c('div',{staticClass:"md fs22"},[_c('vue_markdown',{attrs:{"source":_vm.mdtext}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }